export default __webpack_public_path__ + "static/media/Kealogo.727b0752.png";